import AppContext from "PFApp/app_context";
import { useContext } from "react";

import { checkIsFilterActive } from "../utils/utils";

export const useIsSkillFilterActive = () => {
  const {
    store: {
      pages: {
        insights: {
          insightsMeta: { filterTypes }
        }
      }
    }
  } = useContext(AppContext);

  return checkIsFilterActive("skills", filterTypes);
};
